define(['app/modules/degree', 'app/modules/experience', 'app/modules/language'], function(Degree, Experience, Language) {

  var updatePhotoAndResume = function(model_name) {
    // Update photo manually
    var existingPhoto = $('#'+model_name+'_existing_photo');
    var uploader = existingPhoto.closest('.upload-field');
    var photoUrl = existingPhoto.val();
    if(photoUrl && photoUrl != ''){
      if(uploader.find('img').length == 0) uploader.prepend($('<img>'));
      var image = uploader.find('img');
      if (!image.attr('src')) {
        image.attr('src', photoUrl);
        image.show();
      }
    }

    // Update resume manually
    var existingResume = $('#'+model_name+'_existing_resume');
    var uploader = existingResume.closest('.upload-field');
    var resumeUrl = existingResume.val();
    if(resumeUrl && resumeUrl != ''){
      var resumeTitle = uploader.find('.upload-content .title');
      var splittedUrl = resumeUrl.split('/');
      var filename = splittedUrl[splittedUrl.length - 1];
      uploader.attr('data-filename', filename);
      resumeTitle.html("<a href='" + resumeUrl + "' target='_blank'></a><span class='resume-filename'>" + filename + "</span>");
    }
  };

  var loadForm = function(model_name, suffix) {
    var savedForm = localStorage[model_name + '_' + suffix];
    if (!savedForm) {
      updatePhotoAndResume(model_name);
      return;
    }
    var languagesExists = $('.education-fields.language').length > 1;
    var degreesExist = $('.education-fields.degree').length > 1;
    var experiencesExists = $('.education-fields.experience').length > 1;
    var hiddenObject = {
      'languages_attributes': {},
      'degrees_attributes': {},
      'experiences_attributes': {}
    };
    JSON.parse(savedForm).forEach(function (item) {
      var parsedName = item.name.split('[');
      parsedName.forEach(function(item, index, array){
        if (item[item.length - 1] == ']') {
          array[index] = item.slice(0, -1);
        }
      });

      if (parsedName.length >= 4) {
        if (parsedName.length == 5) {
          if (!hiddenObject[parsedName[1]][parsedName[3]]) {
            hiddenObject[parsedName[1]][parsedName[3]] = [];
          }
          hiddenObject[parsedName[1]][parsedName[3]].push(item.value);
        } else {
          if (hiddenObject[parsedName[1]] && hiddenObject[parsedName[1]][parsedName[3]]) {
            switch (parsedName[1]) {
              case 'languages_attributes':
                if (!languagesExists) {
                  Language.addHtml(hiddenObject[parsedName[1]], $('.education-fields.language-new'), model_name, true);
                }
                break;
              case 'degrees_attributes':
                if (!degreesExist) {
                  Degree.addHtml(hiddenObject[parsedName[1]], $('.education-fields.education-new'), model_name, true);
                }
                break;
              case 'experiences_attributes':
                if (!experiencesExists) {
                  Experience.addHtml(hiddenObject[parsedName[1]], $('.education-fields.experience-new'), model_name, true);
                }
                break;
              default:
                break;
            }
            hiddenObject[parsedName[1]] = {};
          }
          if (hiddenObject[parsedName[1]]) {
            hiddenObject[parsedName[1]][parsedName[3]] = item.value;
          }
        }
      }
      var target = $('[name="' + item.name + '"]');
      // Found multiple select
      if ($.isArray(target.val())) {
        var newArray = target.val();
        newArray.push(item.value);
        target.val(newArray);
      } else {
        // Found checkbox
        if (item.value == 'on') {
          target.attr('checked', true);
          target.iCheck('update');
        } else if (target.attr('type') == 'radio' && item.value != '') {
          // Update custom questions radios
          target.attr('checked', true);
          target.iCheck('update');
        }
        else {
          // Ordinary fields
          if (!target.val()) {
            target.val(item.value);
          }
        }
        // Update photo manually
        if (parsedName.length == 2 && parsedName[1] == 'existing_photo' && item.value != '') {
          var image = target.parent().parent().find('img');
          if (!image.attr('src')) {
            image.attr('src', item.value);
            image.show();
          }
        }
        // Update resume manually
        if (parsedName.length == 2 && parsedName[1] == 'existing_resume' && item.value != '') {
          var resume_title = target.parent().parent().find('.upload-content .title');
          var splitted_url = item.value.split('/');
          $('.upload-field.resume').attr('data-filename', splitted_url[splitted_url.length - 1]);
          resume_title.html("<a href='" + item.value + "' target='_blank'></a><span class='resume-filename'>" + splitted_url[splitted_url.length - 1] + "</span>");
        }
        // Show fields associated with position
        if (parsedName.length == 2 && parsedName[1] == 'position') {
          var form = $('form');
          if($.inArray(item.value, ['intern', 'entry_level']) !== -1) {
            form.find('.job-type-fields .type-internship').removeClass('hidden');
            form.find('.job-type-fields .type-experienced').addClass('hidden');
          } else if(item.value == 'experienced') {
            form.find('.job-type-fields .type-internship').addClass('hidden');
            form.find('.job-type-fields .type-experienced').removeClass('hidden');
          } else {
            form.find('.job-type-fields .type-internship').addClass('hidden');
            form.find('.job-type-fields .type-experienced').addClass('hidden');
          }
        }
      }
    });
    Object.keys(hiddenObject).forEach(function(key) {
      switch (key) {
        case 'languages_attributes':
          if (!languagesExists) {
            Language.addHtml(hiddenObject[key], $('.education-fields.language-new'), model_name, true);
          }
          break;
        case 'degrees_attributes':
          if (!degreesExist) {
            Degree.addHtml(hiddenObject[key], $('.education-fields.education-new'), model_name, true);
          }
          break;
        case 'experiences_attributes':
          if (!experiencesExists) {
            Experience.addHtml(hiddenObject[key], $('.education-fields.experience-new'), model_name, true);
          }
          break;
        default:
          break;
      }
      hiddenObject[key] = {};
    });
    $('select').trigger("chosen:updated");
    $('.datepicker-month,.datepicker-year-month,.datepicker-year-month-day').change();

    $(document).trigger('form:updated');
  };

  return {
    loadForm: loadForm
  };
});
